import { bbox } from "@turf/turf";
import { useMemo, useEffect, RefObject } from "react";
import { MapRef } from "react-map-gl/mapbox";
import { UseSelectedIncidentBoundsParams } from "../../types";

export function useSelectedIncidentBounds({
  bufferArea,
  selectedIncidentShapes,
}: UseSelectedIncidentBoundsParams) {
  return useMemo(() => {
    if (!selectedIncidentShapes?.features?.length && bufferArea?.length)
      return bbox(bufferArea[0]);
    if (!selectedIncidentShapes?.features?.length) return null;

    return bbox(selectedIncidentShapes);
  }, [bufferArea, selectedIncidentShapes]);
}

export function useFitSelectedIncidentBounds(
  mapRef: RefObject<MapRef | null>,
  selectedIncidentBounds: Array<number> | null,
) {
  useEffect(() => {
    if (!mapRef.current || !selectedIncidentBounds) return;

    mapRef.current.fitBounds(
      [
        [selectedIncidentBounds[0], selectedIncidentBounds[1]],
        [selectedIncidentBounds[2], selectedIncidentBounds[3]],
      ],
      { padding: 40, duration: 1000 },
    );
  }, [mapRef, selectedIncidentBounds]);
}
